module.exports = "ion-fab ion-fab-button {\n  --background: #0088FF;\n  --background-activated: #0088FF;\n  --background-focused: #0088FF;\n  --background-hover: #0088FF;\n  color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/detalhe-pdf/detalhe-pdf.component.scss
// module id = ./src/app/components/detalhe-pdf/detalhe-pdf.component.scss
// module chunks = main